import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header'
import { Button, Col, Dropdown, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import ReusableTable from '../../components/ReusableTable';
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import { useSelector } from 'react-redux';

const OutletUsers = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [outletAccess, setOutletAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
              perm?.startsWith("OutletUser:")
            );
            setOutletAccess(filteredAccess);
        }
    }, [access]);

    console.log("Outlet Access:", outletAccess);
    
    const accessToken = localStorage.getItem("authToken");
    const [inputData, setInputData] = useState({
        outlet: "",
        name: "",
        role: "",
        mobile: "",
        email: "",
        password: "",
    });
    const [outletUsers, setOutletUsers] = useState([]);
    const [outlets, setOutlets] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [searchText, setSearchText] = useState("");
    const [validationErrors, setValidationErrors] = useState({
        outlet: "",
        name: "",
        role: "",
        mobile: "",
        email: "",
        password: "",
    });
    const [editValidationErrors, setEditValidationErrors] = useState({
        outlet: "",
        name: "",
        role: "",
        mobile: "",
        email: "",
        password: "",
    });
    const [dataLoading, setDataLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [outletUserId, setOutletUserId] = useState('');
    const [outletUserDetail, setOutletUserDetail] = useState({});
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedOutlet, setSelectedOutlet] = useState('');

    const columns = [
        { header: "Sr.No", accessor: "serialNumber" },
        {
            header: "User Name",
            accessor: "name",
            render: (value, row) => (
                <div>
                    <h6 className="mb-0">{value}</h6>
                    <span className="fs-xs text-secondary">{row.email}</span>
                </div>
            ),
        },
        { header: "Contact", accessor: "mobile",
            render: (value, row) => (
                <div>
                    <span className='text-primary'>{value}</span>
                </div>
            )
        },
        {
            header: "Role",
            accessor: "idNumber",
            render: (value, row) => (
                <div>
                    <h6 className="mb-0">{row.role}</h6>
                    <span className="mb-0 text-muted">{value}</span>
                </div>
            ),
        },
        
        {
            header: "Outlet",
            accessor: "role",
            render: (value, row) => (
                <div>
                    <h6 className="mb-0">{row?.outlet?.name}</h6>
                    <span className="fs-xs text-secondary">{row.country}</span>
                </div>
            ),
        },
        {
            header: "Outlet Status",
            accessor: "status",
            render: (value) => (
                <span
                    className={`badge ${
                        value === "ACTIVE"
                        ? "bg-success"
                        : value === "COMING_SOON"
                        ? "bg-warning"
                        : "bg-danger"
                    }`}
                >
                    {value}
                </span>
            ),
        },
        {
            header: "Actions",
            accessor: null,
            render: (_, row) => (
                <div className="d-flex justify-content-center">
                <Dropdown>
                    <Dropdown.Toggle variant="link" className="p-0 m-0 border-0">
                    <i className="ri-more-2-fill" style={{ cursor: "pointer" }}></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                        {(outletAccess?.includes("OutletUser:update") || email === 'contact@xpansecafe.com') && (
                          <Dropdown.Item
                              className="text-primary"
                              onClick={() => handleEditModal(row)}
                          >
                              Edit
                          </Dropdown.Item>
                        )}
                        {(outletAccess?.includes("OutletUser:get") || email === 'contact@xpansecafe.com') && (
                          <Dropdown.Item
                              className="text-success"
                              onClick={() => handleOpenViewModal(row)}
                          >
                              View
                          </Dropdown.Item>
                        )}
                        {(outletAccess?.includes("OutletUser:delete") || email === 'contact@xpansecafe.com') && (
                          <Dropdown.Item
                              className="text-danger"
                              onClick={() => handleDeleteModal(row)}
                          >
                              Delete
                          </Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                </Dropdown>
                </div>
            ),
        },
    ];

    const getOutletUsers = async (outId) => {
        setDataLoading(true);
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          let newUrl = `outlet/user`;
          if (outId) {
            newUrl += `?outlet=${outId}`
          }
          const response = await axios.get(newUrl, { headers });
    
          if (response?.data?.status === true) {
            response?.data?.data?.outletUsers.forEach((item, index) => {
              item.serialNumber = index + 1;
            });
    
            setOutletUsers(response?.data?.data?.outletUsers);
            setFilteredData(response?.data?.data?.outletUsers);
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
            setDataLoading(false);
        }
    };

    const getSingleOutletUser = async (userId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`outlet/user?_id=${userId}`, {
                headers,
            });
        
            if (response?.data?.status === true) {
                setOutletUserDetail(response?.data?.data?.outletUsers);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
                });
            }
        }
    };

    const getOutlets = async () => {
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axios.get("outlet", { headers });
    
          if (response?.data?.status === true) {
            setOutlets(response?.data?.data?.outlets);
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
    };

    const handleOpenViewModal = (data) => {
        getSingleOutletUser(data?._id);
        setOpenViewModal(true);
    };

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputData((prevState) => ({ ...prevState, [name]: value }));
        setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!inputData.outlet) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            outlet: "Outlet is required.",
          }));
          return;
        }
    
        if (!inputData.name) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            name: "Name is required.",
          }));
          return;
        }
    
        if (!inputData.role) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            role: "Role is required.",
          }));
          return;
        }
        if (!inputData.mobile) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            mobile: "Mobile is required.",
          }));
          return;
        }
    
        if (inputData.mobile.length !== 10) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            mobile: "Mobile Number Must be 10 digits.",
          }));
          return;
        }
        if (!/^\d+$/u.test(inputData.mobile)) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            mobile: "Invalid mobile number. Please enter only numeric characters.",
          }));
          return;
        }
    
        if (!inputData.email) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            email: "email is required.",
          }));
          return;
        }
        if (!inputData.password) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            password: "password is required.",
          }));
          return;
        }
    
        if (Object.values(validationErrors).some((error) => error !== "")) {
          return;
        }
        setIsLoading(true);
    
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
    
          const response = await axios.post("outlet/user", inputData, { headers });
    
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
    
            getOutletUsers(selectedOutlet);
    
            setInputData({
              outlet: "",
              name: "",
              role: "",
              mobile: "",
              email: "",
              password: "",
            });
            setOpenAddModal(false);
          }
        } catch (error) {
          if (error?.response) {
            let errorMessage = '';
            if (
              error.response?.status === 406
            ) {
              errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            }
            else if (
              error.response?.status === 412
            ) {
              errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
              errorMessage = error?.response?.data?.error
            }
    
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsLoading(false);
        }
    };

    const handleEditModal = async (data) => {
        setEditedData({
          _id: data._id,
          outlet: data.outlet._id,
          name: data.name,
          role: data.role,
          mobile: data.mobile,
          email: data.email,
          password: data.password,
          status: data.status,
        });
        setOutletUserId(data._id);
        setOpenEditModal(true);
    };
    
    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData((prevState) => ({ ...prevState, [name]: value }));
        setEditValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
    
        if (!editedData.outlet) {
          setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            outlet: "Outlet is required.",
          }));
          return;
        }
    
        if (!editedData.name) {
          setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            name: "Name is required.",
          }));
          return;
        }
    
        if (!editedData.role) {
          setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            role: "Role is required.",
          }));
          return;
        }
        if (!editedData.mobile) {
          setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            mobile: "Mobile is required.",
          }));
          return;
        }
    
        if (editedData.mobile.length !== 10) {
          setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            mobile: "Mobile Number Must be 10 digits.",
          }));
          return;
        }
        if (!/^\d+$/u.test(editedData.mobile)) {
          setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            mobile: "Invalid mobile number. Please enter only numeric characters.",
          }));
          return;
        }
    
        if (!editedData.email) {
          setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            email: "Email is required.",
          }));
          return;
        }
        if (!editedData.password) {
          setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            password: "Password is required.",
          }));
          return;
        }
        if (!editedData.status) {
          setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            status: "Status is required.",
          }));
          return;
        }
    
        if (Object.values(editValidationErrors).some((error) => error !== "")) {
          return;
        }
    
        setIsEditBtnLoading(true);
    
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axios.put("outlet/user", editedData, { headers });
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            getOutletUsers(selectedOutlet);
            setOpenEditModal(false);
            getSingleOutletUser(outletUserId);
            setOpenViewModal(true);
            setOutletUserId("");
          }
        } catch (error) {
          if (error?.response) {
            let errorMessage = '';
            if (
              error.response?.status === 406
            ) {
              errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            }
            else if (
              error.response?.status === 412
            ) {
              errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
              errorMessage = error?.response?.data?.error
            }
    
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsEditBtnLoading(false);
        }
    };

    const handleDeleteModal = async (data) => {
        setOpenDeleteModal(true);
        setOutletUserId(data?._id);
    };

    const handleDeleteOutletUser = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
    
          const data = {
            _id: outletUserId,
          };
          const response = await axios.delete(`outlet/user`, { data, headers });
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            getOutletUsers(selectedOutlet);
            setOpenDeleteModal(false);
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsDeleteBtnLoading(false);
        }
    };

    const handlePageChange = (page) => {
      setPage(page);
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPage(1);
        setRowsPerPage(rowsPerPage);
    };

    const getPaginatedData = () => {
        const startIndex = (page - 1) * rowsPerPage;
        
        const endIndex = startIndex + rowsPerPage;

        return filteredData?.slice(startIndex, endIndex);
    };

    const handleOutletChange = async(e) => {
      let outId = e.target.value
      setSelectedOutlet(e.target.value);
      getOutletUsers(outId);
    }

    useEffect(() => {
        getOutletUsers();
        getOutlets();
    }, []);

    function escapeRegExp(text) {
        return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    const editButtonDisable =
        !editedData ||
        !editedData.outlet ||
        !editedData.name?.trim() ||
        !editedData.role ||
        !editedData.mobile ||
        editedData.mobile.length < 10 ||
        !editedData.email?.trim() ||
        !editedData.status;

    useEffect(() => {
        const escapedSearchText = escapeRegExp(searchText);
        const regex = new RegExp(escapedSearchText, "i");
    
        const result = outletUsers.filter(
          (item) =>
            item.name.match(regex) ||
            item.email.match(regex) ||
            item.mobile.match(regex) ||
            item.idNumber.match(regex) ||
            item.role.match(regex) ||
            item.status.match(regex)
        );
    
        setFilteredData(result);
    }, [searchText]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div
                    className="container shadow-sm"
                    style={{ backgroundColor: "white" }}
                >
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold">OUTLET USERS MANAGEMENT</h5>
                        </Col>
                        <hr />
                    </Row>

                    <Row className='justify-content-between mt-2'>
                        <Col lg="4">
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    className="form-control"
                                    placeholder="Search for outlets users..."
                                />
                                <button className="btn btn-primary" type="button">
                                    <i className="ri-search-line"></i>
                                </button>
                            </div>
                        </Col>
                        <Col md={3}>
                          <Form.Group controlId="outletSelect">
                            <Form.Select
                                value={selectedOutlet}
                                onChange={handleOutletChange}
                                className="border-secondary"
                            >
                                <option value="">All Outlets</option>
                                {outlets?.map((outlet) => (
                                    <option
                                        key={outlet._id}
                                        value={outlet._id}
                                        style={{
                                            color:
                                            outlet?.status === 'ACTIVE'
                                                ? 'black'
                                                : outlet?.status === 'INACTIVE'
                                                ? 'red'
                                                : 'GrayText'
                                        }}
                                    >
                                        {outlet.name} {outlet?.status !== 'ACTIVE' ? ` - ${outlet?.status}` : ''}
                                    </option>
                                ))}
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        <Col lg="3" className="d-flex justify-content-end flex-column">
                            <Button
                                variant="primary"
                                className="fw-semibold"
                                onClick={handleOpenAddModal}
                            >
                                <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                Add New Outlet User
                            </Button>
                        </Col>
                    </Row>

                    <Row className='mt-3'>
                        <Col>
                          {(outletAccess?.includes("OutletUser:get") || email === 'contact@xpansecafe.com') && (
                            <ReusableTable
                              columns={columns}
                              data={getPaginatedData()}
                              rowKey="serialNumber"
                              loading={dataLoading}
                              currentPage={page}
                              recordsPerPage={rowsPerPage}
                              onPageChange={handlePageChange}
                              totalPages={Math.ceil(filteredData?.length / rowsPerPage)}
                              onRecordsPerPageChange={handleRowsPerPageChange}
                            />
                          )}
                        </Col>
                    </Row>


                    {openAddModal && (
                        <Modal
                            centered
                            show={openAddModal}
                            onHide={() => setOpenAddModal(false)}
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                            <Modal.Title>Add New Outlet User</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Row>
                                <Col>
                                    <div className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Select Outlet <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        onChange={handleChange}
                                        name="outlet"
                                        aria-label="Small select example"
                                    >
                                        <option>Select Outlet</option>
                                        {outlets.map((rm) => (
                                        <option key={rm._id} value={rm._id}>
                                            {rm.name}
                                        </option>
                                        ))}
                                    </Form.Select>
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                        {validationErrors.outlet}
                                    </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Select Role <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        onChange={handleChange}
                                        name="role"
                                        aria-label="Small select example"
                                    >
                                        <option>Select Role</option>
                                        <option value="CAFE-MANAGER">CAFE-MANAGER</option>
                                        <option value="MANAGER">MANAGER</option>
                                        <option value="CASHIER">CASHIER</option>
                                    </Form.Select>
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                        {validationErrors.role}
                                    </div>
                                    </div>
                                </Col>
                                </Row>
                                <Row>
                                <Col>
                                    <div className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Name <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Name"
                                        name="name"
                                        value={inputData.name}
                                        onChange={handleChange}
                                    />
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                        {validationErrors.name}
                                    </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Email <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Email"
                                        name="email"
                                        value={inputData.email}
                                        onChange={handleChange}
                                    />
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                        {validationErrors.email}
                                    </div>
                                    </div>
                                </Col>
                                </Row>
                                <Row>
                                <Col>
                                    <div className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Mobile <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        min={1}
                                        minLength={10}
                                        type="number"
                                        placeholder="Mobile"
                                        name="mobile"
                                        value={inputData.mobile}
                                        onChange={handleChange}
                                    />
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                        {validationErrors.mobile}
                                    </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Password <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Password"
                                        name="password"
                                        value={inputData.password}
                                        onChange={handleChange}
                                    />
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                        {validationErrors.password}
                                    </div>
                                    </div>
                                </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    type="submit"
                                    variant="primary"
                                >
                                    { isLoading ? 
                                        <Spinner 
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    : "Add New User"}
                                </Button>
                            </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {openEditModal && (
                        <Modal
                            show={openEditModal}
                            onHide={() => setOpenEditModal(false)}
                            centered
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton style={{ backgroundColor: "#f8f8f8" }}>
                            <Modal.Title id="VerticallyCenteredExample" className="fs-6 fw-semibold">
                                EDIT OUTLET USER
                            </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditSubmit}>
                            <Modal.Body>
                                <Row>
                                <Col>
                                    <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Select Outlet <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="outlet"
                                        value={editedData.outlet}
                                        onChange={handleEditChange}
                                    >
                                        <option>Select Outlet</option>
                                        {outlets.map((rm) => (
                                        <option key={rm._id} value={rm._id}>
                                            {rm.name}
                                        </option>
                                        ))}
                                    </Form.Select>
                                    {editValidationErrors.outlet && (
                                        <div style={{ color: "red", fontSize: "12px" }}>
                                        {editValidationErrors.outlet}
                                        </div>
                                    )}
                                    </Form.Group>
                                </Col>
                                  <Col>
                                      <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                            Select Role <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            name="role"
                                            value={editedData.role}
                                            onChange={handleEditChange}
                                        >
                                            <option>Select Role</option>
                                            <option value="CAFE-MANAGER">CAFE-MANAGER</option>
                                            <option value="MANAGER">MANAGER</option>
                                            <option value="CASHIER">CASHIER</option>
                                        </Form.Select>
                                        {editValidationErrors.role && (
                                            <div style={{ color: "red", fontSize: "12px" }}>
                                            {editValidationErrors.role}
                                            </div>
                                        )}
                                      </Form.Group>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                      <Form.Group className="mb-3">
                                      <Form.Label className="fw-semibold">
                                          Name <span className="text-danger">*</span>
                                      </Form.Label>
                                      <Form.Control
                                          type="text"
                                          placeholder="Name"
                                          name="name"
                                          value={editedData.name}
                                          onChange={handleEditChange}
                                      />
                                      {editValidationErrors.name && (
                                          <div style={{ color: "red", fontSize: "12px" }}>
                                          {editValidationErrors.name}
                                          </div>
                                      )}
                                      </Form.Group>
                                  </Col>
                                  <Col>
                                      <Form.Group className="mb-3">
                                      <Form.Label className="fw-semibold">
                                          Email <span className="text-danger">*</span>
                                      </Form.Label>
                                      <Form.Control
                                          type="text"
                                          placeholder="Email"
                                          name="email"
                                          value={editedData.email}
                                          onChange={handleEditChange}
                                      />
                                      {editValidationErrors.email && (
                                          <div style={{ color: "red", fontSize: "12px" }}>
                                          {editValidationErrors.email}
                                          </div>
                                      )}
                                      </Form.Group>
                                  </Col>
                                </Row>
                                <Row>
                                <Col>
                                    <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Mobile <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Mobile"
                                        name="mobile"
                                        value={editedData.mobile}
                                        onChange={handleEditChange}
                                    />
                                    {editValidationErrors.mobile && (
                                        <div style={{ color: "red", fontSize: "12px" }}>
                                        {editValidationErrors.mobile}
                                        </div>
                                    )}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">
                                        Select Status <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="status"
                                        value={editedData.status}
                                        onChange={handleEditChange}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="ACTIVE">ACTIVE</option>
                                        <option value="INACTIVE">INACTIVE</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                variant="primary"
                                type="submit"
                                disabled={editButtonDisable}
                                >
                                {isEditBtnLoading ? "Saving..." : "SAVE CHANGES"}
                                </Button>
                            </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {openViewModal && (
                        <Modal
                            show={openViewModal}
                            onHide={() => setOpenViewModal(false)}
                            centered
                            aria-labelledby="view-outlet-user-modal"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="view-outlet-user-modal">
                                    View Outlet User Details
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {/* Outlet User Details */}
                                <div className="mb-2">
                                    <h5 className="text-secondary">Outlet User Details</h5>
                                    <Table responsive bordered>
                                    <tbody>
                                        <tr>
                                            <td>ID Number</td>
                                            <td>{outletUserDetail?.idNumber || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td>Name</td>
                                            <td>{outletUserDetail?.name || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td>Email</td>
                                            <td>{outletUserDetail?.email || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td>Role</td>
                                            <td>{outletUserDetail?.role || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td>Mobile</td>
                                            <td>{outletUserDetail?.mobile || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td>Status</td>
                                            <td>{outletUserDetail?.status || "N/A"}</td>
                                        </tr>
                                    </tbody>
                                    </Table>
                                </div>
                    
                                {/* Outlet Details */}
                                <div>
                                    <h5 className="text-secondary">Outlet Details</h5>
                                    <Table responsive bordered>
                                    <tbody>
                                        <tr>
                                            <td>Name</td>
                                            <td>{outletUserDetail?.outlet?.name || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td>City, State</td>
                                            <td>
                                                {outletUserDetail?.outlet?.city || "N/A"}, {" "}
                                                {outletUserDetail?.outlet?.state || "N/A"}
                                            </td>
                                        </tr>
                                    </tbody>
                                    </Table>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="warning"
                                    onClick={() => setOpenViewModal(false)}
                                >
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}

                    {/* <---------------- Delete Outlet Modal ------------> */}
                    {openDeleteModal && (
                        <Modal show={openDeleteModal} onClose={() => setOpenDeleteModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirm Delete</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Are you sure you want to delete this outlet user? This action cannot be undone.
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                                    Cancel
                                </Button>
                                <Button variant="danger" onClick={handleDeleteOutletUser}>
                                    { isDeleteBtnLoading ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        /> :
                                        "Delete Outlet User"                                
                                    }
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}

export default OutletUsers